"use strict";
exports.__esModule = true;
function getCompareToInfo() {
    var compareArea = $("#compareArea").children();
    if (compareArea.length) {
        var ele = compareArea[0];
        if (ele.id && ele.id.length > 8) {
            return {
                id: ele.id.substring(8),
                name: ele.innerText || ele.textContent
            };
        }
    }
    return null;
}
exports.getCompareToInfo = getCompareToInfo;
//# sourceMappingURL=report-options.helper.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/report-options.helper.js